import React, { useMemo } from 'react';
import {
    PlayerWaveform as ReactPlayerWaveform,
    PlayerWaveformTheme,
    PlayerWaveformConfig,
    PlayerWaveformDataPoints,
} from '@landr/react-player';
import { withErrorBoundary } from 'error';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { useWaveformTheme, useThemeProvider } from '@landr/maestro';

const waveformConfig: Partial<PlayerWaveformConfig> = {
    mirrored: true,
    playOnSeek: false,
    silenceBarHeight: 1,
};

interface PlayerWaveformProps {
    dataPoints: PlayerWaveformDataPoints;
    guid: string;
}

const PlayerWaveform = ({
    dataPoints,
    guid,
}: {
    dataPoints: PlayerWaveformDataPoints;
    guid: string;
}): JSX.Element => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();

    const theme = useThemeProvider();
    const waveformTheme = useWaveformTheme();

    // this theme mask the progression and hover color
    const samplesPluginWaveformTheme: PlayerWaveformTheme = useMemo(() => {
        return {
            original: {
                barColor: theme.colors.waveform.original.default,
                barProgressColor: theme.colors.waveform.original.played,
                barProgressColorAfterPosition:
                    theme.colors.waveform.original.default,
                barHoverColor: theme.colors.waveform.original.default,
                animInSpeed: 0,
            },
        };
    }, [theme]);

    return (
        <ReactPlayerWaveform
            theme={isDAWPlugin ? samplesPluginWaveformTheme : waveformTheme}
            playerId={guid}
            dataPoints={dataPoints}
            config={waveformConfig}
            isResizable
        />
    );
};

PlayerWaveform.displayName = 'PlayerWaveform';

export default withErrorBoundary<PlayerWaveformProps>(
    PlayerWaveform,
    'minimal',
);
